export default "__VITE_ASSET__CgSOq5ZY__"